<div class="p-4 md:p-8">
  <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden;">
    <!-- Header -->
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;">
      <div style="display: flex; align-items: center; gap: 10px;">
        <mat-icon style="font-size: 24px; width: 24px; height: 24px; color: #1C593D;">account_balance</mat-icon>
        <span style="font-size: 1.1rem; font-weight: 800; color: #1e5a3f;">Cuentas de retiro</span>
      </div>
      <button type="button" (click)="openCreateDialog()"
        style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">add_circle</mat-icon>
        Agregar cuenta
      </button>
    </div>

    <!-- List -->
    <div style="padding: 16px 24px;">
      <app-withdraw-account-list [listaCuentas]="listaCuentas" (seleccion)="onSeleccion($event)" (reloadAccountList)="reloadAccount()" [seleccionable]="seleccionable" (actualizarCuenta)="openCreateDialog($event)"></app-withdraw-account-list>

      <!-- Empty state -->
      <div *ngIf="!listaCuentas || listaCuentas.length === 0"
        style="display: flex; flex-direction: column; align-items: center; padding: 40px 20px; color: #9ca3af;">
        <mat-icon style="font-size: 48px; width: 48px; height: 48px; margin-bottom: 8px;">account_balance_wallet</mat-icon>
        <p style="font-size: 0.9rem; font-weight: 500; margin: 0;">No tienes cuentas de retiro registradas</p>
      </div>
    </div>
  </div>
</div>
